// 引入封装axios服务
import request from '@/utils/request'
// request 二次处理
import awaitWrap from '@/utils/awaitWrap'

const baseURL = process.env.VUE_APP_BASE_API // 石汉
const baseURLC = process.env.VUE_APP_BASE_API // 尹力维
const baseURLY = process.env.VUE_APP_BASE_API // 余超
const baseURLG = process.env.VUE_APP_BASE_API // 高泽鹏
const baseURLK = process.env.VUE_APP_KA_BASE_API // 高泽鹏

/**
 * 获取json 新对象，去掉空字段
 * @param {Object} data
 * @returns
 */
export function getClearJson(data) {
  const _data = {}
  for (const prop in data) {
    const item = data[prop]
    if (item !== undefined && item) {
      _data[prop] = item
    }
  }
  return _data
}

/**
 * requestB baserUrl重写
 * @param {Object} data
 * @returns
 */
const requestB = (data) => {
  return request({
    ...data,
    ...{
      baseURL
    }
  })
}

const requestC = (data) => {
  return request({
    ...data,
    ...{
      baseURL: baseURLC
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
const requestY = (data) => {
  return request({
    ...data,
    ...{
      baseURL: baseURLY
    }
  })
}

const requestG = (data) => {
  return request({
    ...data,
    ...{
      baseURL: baseURLG
    }
  })
}

const requestK = (data) => {
  return request({
    ...data,
    ...{
      baseURL: baseURLK
    }
  })
}
// const requestCall = (data) => {
//   return request({
//     ...data,
//     ...{
//       baseURL: process.env.VUE_APP_BASE_API
//     },
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
// }

// 业务表单下拉框数据
export function structureList() {
  return requestB({
    url: '/form/structure/list',
    method: 'get'
  })
}

// 业务表单id获取其中表单字段
export function columnList(data) {
  return requestB({
    url: '/form/structure/column/list',
    method: 'get',
    params: data
  })
}

// 业务表单id获取其中表单字段
export function kaColumnList(data) {
  return requestK({
    url: '/bpm/form/structure/column/list',
    method: 'get',
    params: data,
    baseURL
  })
}

// 组织架构树形结构查询
export function getDepartmentTree(data) {
  return requestC({
    url: '/common/getDepartmentTree',
    method: 'post',
    data
  })
}

// 组织架构部门下人员数据
export function getDepartmentUsers(data) {
  return requestC({
    url: '/common/getUserDetailList',
    method: 'post',
    data
  })
}

// 获取审批角色
export function roleList(data) {
  return requestC({
    url: '/role/queryList',
    method: 'post',
    data
  })
}

// 获取角色身份(潍柴需要)
export function wcRoleList(data) {
  return requestC({
    url: '/role/queryList',
    method: 'get',
    params: data
  })
}

// 新增审批规则
export function addRule(data) {
  return requestG({
    url: '/approvalRule/addRule',
    method: 'post',
    data
  })
}

// 新增审批规则V1.1
export function addProcessRule(data) {
  return requestG({
    url: '/processRule/addRule',
    method: 'post',
    data
  })
}

// 编辑审批规则V1.1
export function updateProcessRule(data) {
  return requestG({
    url: '/processRule/updRule',
    method: 'post',
    data
  })
}

// 根据表单id和部门id集合查询已配置的规则列表（冲突列表）
export function conflictList(data) {
  return requestG({
    url: '/approvalRule/conflictList',
    method: 'post',
    data
  })
}

// 根据表单id查询已配置的部门列表
export function getlDepartmentByformId(data) {
  return requestG({
    url: '/approvalRule/getlDepartmentByformId',
    method: 'post',
    data
  })
}

// 根据表单id和部门id集合查询已配置的规则列表（下载冲突列表）
export function downConflictList(data) {
  return requestG({
    url: '/approvalRule/downConflictList',
    method: 'post',
    data,
    responseType: 'blob' // 定义为blob
  })
}

// 查看审批规则详情
export function getlRuleDetail(data) {
  return requestG({
    url: '/approvalRule/getlRuleDetail',
    method: 'post',
    params: data
  })
}

// 条件查询审批规则列表
export function queryRuleList(data) {
  return requestG({
    url: '/processRule/queryRuleList',
    method: 'post',
    data
  })
}

// 启用/禁用审批规则
export function enableRule(data) {
  return awaitWrap(requestG({
    url: '/approvalRule/enable',
    method: 'post',
    data
  }))
}

// 删除审批规则
export function delRule(data) {
  return requestG({
    url: '/approvalRule/delRule',
    method: 'post',
    params: data
  })
}

// 编辑审批规则
export function updateRule(data) {
  return requestG({
    url: '/approvalRule/updRule',
    method: 'post',
    data
  })
}

// 员工组织架构树形结构查询
// export function getUserDepartmentTree(data) {
//   return requestC({
//     url: '/common/getUserDepartmentTree',
//     method: 'post',
//     data
//   })
// }

// 审批首页
export function homeIndex() {
  return requestY({
    url: '/approve/query/index',
    method: 'get'
  })
}

// 我的审批-全部(表单id必填)
export function approveAllList(data) {
  return requestY({
    url: '/approve/query/allList',
    method: 'post',
    data
  })
}

// 我的审批-待审批(表单id必填)
export function approveTodoList(data) {
  return requestY({
    url: '/approve/query/todoList',
    method: 'post',
    data
  })
}

// 我的审批-已审批(表单id必填)
export function approveFinishedList(data) {
  return requestY({
    url: '/approve/query/finishedList',
    method: 'post',
    data
  })
}

// 获取抄送列表
export function approveCopyList(data) {
  return requestY({
    url: '/approve/query/copyList',
    method: 'post',
    data
  })
}

// 获取动态表单-根据showType，
// 【查询条件，table列表，详情】需要展示哪些formData的字段
export function dynamicSelectList(data) {
  return requestY({
    url: '/scrm/professional/process_center/dynamicSelectList',
    method: 'post',
    data
  })
}

export function approveStatusList(data) {
  return requestY({
    url: '/approve/query/dropApproveStatus',
    method: 'post',
    data
  })
}

// 导出excel
export function approveExport(data) {
  return requestY({
    url: '/approve/query/export',
    method: 'post',
    data,
    responseType: 'blob' // 定义为blob
  })
}

// 查询流程【流转】实例详情
export function processInstance(procInsId) {
  return requestY({
    url: `/approve/query/detail/${procInsId}`,
    method: 'get'
  })
}

// 通过前-可以修改的动态表单字段
export function completeDynamicColumnList(id) {
  return requestY({
    url: '/approve/operate/completeDynamicColumnList',
    method: 'get',
    params: id
  })
}

// 审批--通过
export function approvePass(data) {
  return requestY({
    url: '/approve/operate/complete',
    method: 'post',
    data
  })
}

// 审批--驳回
export function approveReject(data) {
  return requestY({
    url: '/approve/operate/reject',
    method: 'post',
    data
  })
}

// 首页流程发起
export function launchList(data = {}) {
  return requestY({
    url: '/approvalRule/getEnableRuleList',
    method: 'post',
    data
  })
}

// 首页-我的待办数统计
export function getTodoCount(params) {
  return requestY({
    url: `/bpm/index/todoCount`,
    method: 'get',
    params
  })
}

// 查询登录人所能发起的流程列表
export function getEnableRuleList(data = {}) {
  return requestY({
    url: '/processRule/getEnableRuleList',
    method: 'post',
    data
  })
}

// 首页-我的待办数统计
export function checkTodoCount(data) {
  return requestB({
    url: '/taskManager/todoTask',
    method: 'post',
    data
  })
}

// 首页-办理历史列表
export function checkDoneCount(data) {
  return requestB({
    url: '/taskManager/finishedTaskList',
    method: 'post',
    data
  })
}

// 首页-抄送我的列表
export function checkCopyCount(data) {
  return requestB({
    url: '/flowCopy/queryCopyList',
    method: 'post',
    data
  })
}

// 首页-小铃铛
export function getMessageNotice() {
  return requestY({
    url: '/sysMessage/queryMessageNotice',
    method: 'get'
  })
}

export function getMessageRead(id) {
  return requestY({
    url: `/sysMessage/readConfirm/${id}`,
    method: 'get'
  })
}

// 清空消息
export function clearMessageNotice(data = {}) {
  return requestY({
    url: '/sysMessage/clearMessageNotice',
    method: 'post',
    data
  })
}

export function getFormDetail(id) {
  return requestY({
    url: `/customer_form/${id}`,
    method: 'get'
  })
}
// /actuator/health2
export function judgeShowNotice(id) {
  return requestY({
    url: '/sysMessage/checkOnline',
    method: 'get'
  })
}

// 校验流程和表单是否匹配
export function checkRuleFormMatching(params) {
  return requestY({
    url: '/processRule/checkRuleFormMatching',
    method: 'get',
    params
  })
}

export function queryFieldRuleByNodeId(params) {
  return requestY({
    url: '/rule/node/queryFieldRuleByNodeId',
    method: 'get',
    params
  })
}

export function getYcApproveDetailToken() {
  return requestY({
    url: '/approve/operate/getYcApproveDetailToken',
    method: 'get'
  })
}

